import { type Component, splitProps } from "solid-js";
import { Checkbox as CheckboxPrimitive } from "@kobalte/core";
import { Check } from "@fleet/icons";
import { cn } from "@mealplan/shared";

type CheckboxProps = CheckboxPrimitive.CheckboxRootProps & {
  class?: string;
  tabIndex?: number;
};

const Checkbox: Component<CheckboxProps> = (props) => {
  const [local, rest] = splitProps(props, ["class", "tabIndex"]);
  return (
    <CheckboxPrimitive.Root class={cn("items-top flex space-x-2", local.class)} {...rest}>
      <CheckboxPrimitive.Input
        class="peer focus-visible:outline-none focus-visible:ring-0"
        tabIndex={local.tabIndex}
      />
      <CheckboxPrimitive.Control
        class={cn(
          "peer h-5 w-5 shrink-0 rounded-md border-2 border-primary cursor-pointer",
          "transition-[transform,background-color,border-color] duration-100 hover:scale-110 active:scale-90",
          "peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-primary",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "data-[checked]:bg-primary data-[checked]:text-primary-foreground data-[checked]:border-primary",
          "hover:border-primary/80",
        )}
      >
        <CheckboxPrimitive.Indicator class="flex items-center justify-center text-current animate-checkmark-pop">
          <Check class="h-3.5 w-3.5 stroke-[3]" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Control>
    </CheckboxPrimitive.Root>
  );
};

export { Checkbox };
